module.exports = " <ul :class=classes> <branch v-for=\"page in pages\" :branch-index=$index :uuid=page.id :title=\"page.title || page.slug\" :url=buildUrl(page.slug) :published=page.published :edit-url=page.edit_url :has-entries=page.has_entries :entries-url=page.entries_url :create-entry-url=page.create_entry_url :child-pages=page.items :collapsed.sync=page.collapsed :depth=depth :sortable=sortable :dirty=dirty></branch> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/page-tree/Branches.vue
// module id = 370
// module chunks = 0